export default __webpack_public_path__ + "static/background2-bb8f6c0edb3c9fe2316708642975fc79.png";